module.exports = __webpack_public_path__ + "img/logo-qeda2.dcb6d9f2.jpg";